export type CourseTrainingProps = {
  detailPagePath?: string;
  launchModulesBtnText?: string;
  continueBtnText?: string;
  relatedCoursesText?: string;
  completionStatusText?: string;
  modulesToCompleteText?: string;
  modulesTabText?: string;
  notesTabText?: string;
  shareBtnText?: string;
};

function htmlDecode(encoded: string): string {
  const div = document.createElement('div');
  div.innerHTML = encoded;
  return div.textContent || '';
}

export function getCourseTrainingPropsFromAEM(
  selector = '.training__page__container'
): CourseTrainingProps | null {
  const el = document.querySelector<HTMLElement>(selector);
  if (!el) return null;
  const raw = el.getAttribute('data-props');
  if (!raw) return null;

  try {
    const decoded = htmlDecode(raw);
    return JSON.parse(decoded);
  } catch (e) {
    console.error('[AEM] Failed to parse data-props:', e);
    return null;
  }
}
